
export const AutoResize = ($timeout: ng.ITimeoutService) => (<angular.IDirective>{

    restrict: 'A',

    link: (scope: any, element: JQLite, attrs: any, ) => {

        element.css({ 'height': 'auto', 'overflow-y': 'hidden' });
        $timeout(() => {
            element.css('height', element[0].scrollHeight + 'px');
        }, 100);

        element.on('input', () => {
            element.css({ 'height': 'auto', 'overflow-y': 'hidden' });
            element.css('height', element[0].scrollHeight + 'px');

        });
    }
});

AutoResize.$inject = ['$timeout'];



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/directives/auto-resize/auto-resize.directive.ts